import _ from "lodash/fp";
import { query } from "../../utilities/query";
import { map, product } from "../../utilities/itertools";
import { createAction } from "redux-actions";

export const fetchOrderStatus = Object.assign(id => (dispatch, getState) => {
  const { signtasks: { data } } = getState();
  const signtask = data[id];

  const request = (signer, document) => {
    if (signer.status.hasOwnProperty(document.reference) || signer.orderId === null) {
      return;
    }

    dispatch(query(fetchOrderStatus)(
      `/api/status/order/${signer.orderId}/singer/${signer.ssn}/document/${document.reference}`,
      "GET",
      undefined,
      { signtaskId: signtask.id, documentReference: document.reference, ssn: signer.ssn }));
  };

  return Promise.all(map(x => request(...x), product(_.values(signtask.signers), _.values(signtask.documents))));
}, {
  success: createAction("signtasks/FETCH_ORDER_STATUS_SUCCESS", _.identity, _.nthArg(1)),
  failure: createAction("signtasks/FETCH_ORDER_STATUS_FAILURE")
});
